/**
 * @desc updateUser
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.SysUserRpcRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/user/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
